const TabsElement = globalThis.HTMLElement ?? class {};

class RilavereTabs extends TabsElement {
  connectedCallback() {
    if (this.dataset.bound === 'true') return;
    this.dataset.bound = 'true';
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    this.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) this.activate(tab);
    });
    this.addEventListener('keydown', (event) => {
      const current = this.tabs.indexOf(event.target);
      if (current < 0 || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const offset = event.key === 'ArrowRight' ? 1 : -1;
      const next = this.tabs[(current + offset + this.tabs.length) % this.tabs.length];
      this.activate(next);
      next.focus();
    });
  }

  activate(activeTab) {
    this.tabs.forEach((tab) => {
      const active = tab === activeTab;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== activeTab.getAttribute('aria-controls');
    });
  }
}

if (globalThis.customElements && !globalThis.customElements.get('rilavere-tabs')) {
  globalThis.customElements.define('rilavere-tabs', RilavereTabs);
}
